// US region → state-code map (#562). Powers the Discover region-preference
// filter: the student saves region words ('West Coast') on their profile; the
// frontend maps them to state codes for the KB list endpoint's `states` param.
// The backend stays region-agnostic. Mountain states (CO/UT/NV/ID/MT/WY) sit
// outside these five buckets by design — "West Coast" means the coast.

export const REGION_STATES = {
    'Northeast': ['CT', 'DC', 'DE', 'MA', 'MD', 'ME', 'NH', 'NJ', 'NY', 'PA', 'RI', 'VT'],
    'Southeast': ['AL', 'AR', 'FL', 'GA', 'KY', 'LA', 'MS', 'NC', 'SC', 'TN', 'VA', 'WV'],
    'Midwest': ['IA', 'IL', 'IN', 'KS', 'MI', 'MN', 'MO', 'ND', 'NE', 'OH', 'SD', 'WI'],
    'Southwest': ['AZ', 'NM', 'OK', 'TX'],
    'West Coast': ['AK', 'CA', 'HI', 'OR', 'WA'],
};

// State codes for a list of saved region names. 'No Preference' (or any
// unknown region) contributes nothing; an empty result means "don't filter".
export function statesForRegions(regions) {
    const out = new Set();
    for (const r of regions || []) {
        for (const s of REGION_STATES[r] || []) out.add(s);
    }
    return [...out].sort();
}

// Two-letter code -> state name, for any public list that groups by state
// (the /colleges index's state filter, #2650).
export const US_STATE_NAMES = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DC: 'District of Columbia', DE: 'Delaware', FL: 'Florida',
    GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana',
    IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', MA: 'Massachusetts',
    MD: 'Maryland', ME: 'Maine', MI: 'Michigan', MN: 'Minnesota', MO: 'Missouri',
    MS: 'Mississippi', MT: 'Montana', NC: 'North Carolina', ND: 'North Dakota', NE: 'Nebraska',
    NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NV: 'Nevada', NY: 'New York',
    OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island',
    SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah',
    VA: 'Virginia', VT: 'Vermont', WA: 'Washington', WI: 'Wisconsin', WV: 'West Virginia', WY: 'Wyoming',
    PR: 'Puerto Rico',
};
